export default function Maps() {
  return (
    <>
      <iframe
      title="map"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3408.6392386147504!2d-110.94787692373139!3d31.313714757321915!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x86d6adfe81e5705f%3A0xbc8e8e87949e0eec!2sBorder%20Protect%20Seguridad%20Privada!5e0!3m2!1ses-419!2smx!4v1741991038489!5m2!1ses-419!2smx"
        className="w-full h-96"
      ></iframe>
    </>
  );
}
